import React from 'react';
import { translateKey } from 'src/locales/translate';
import WarehouseBadge from 'src/sections/@dashboard/warehouse/components/WarehouseBadge';

const HUMAN = 'Ludzki';

interface MedicinePreparationChipProps {
  /** The registry's `preparationType`. */
  preparationType: string;
}

/** "Ludzki" or "Weterynaryjny", as the medicine picker has always shown it. */
export default function MedicinePreparationChip({
  preparationType,
}: MedicinePreparationChipProps): React.ReactElement {
  const human = preparationType === HUMAN;
  const key = human ? 'human' : 'veterinary';
  return (
    <WarehouseBadge
      label={translateKey(`warehouse.medicineSearch.${key}`)}
      hint={translateKey(`warehouse.medicineSearch.${key}Hint`)}
      color={human ? 'info' : 'secondary'}
      icon={human ? 'solar:user-bold' : 'solar:paw-bold'}
    />
  );
}
